import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
// Vendor & Plugin CSS
import "./assets/css/vendor/bootstrap.min.css";
import "./assets/css/vendor/animate.css";
import "./assets/css/plugins/fontawesome-6.css";
import "./assets/css/plugins/swiper.css";
import "./assets/css/plugins/unicons.css";
import "./assets/css/plugins/metismenu.css";

// Custom CSS
import "./assets/css/style.css";



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
